import { MaskLine, Reveal } from "./Reveal";

export default function PageHero({ eyebrow, titleEn, titleJa, desc, image }) {
  return (
    <section className="relative overflow-hidden pb-[45px] pt-[101px] md:pb-[67px] md:pt-[134px]">
      {image && (
        <>
          <img src={image} alt="" className="absolute inset-0 h-full w-full object-cover opacity-20" />
          <div className="absolute inset-0 bg-gradient-to-b from-ink/60 via-ink/80 to-ink" />
        </>
      )}
      <div className="absolute inset-0 bg-blueprint opacity-30" />
      <div data-testid="page-hero" className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <Reveal>
          <p className="flex items-center gap-3 font-mono text-xs tracking-[0.35em] text-accent">
            <span className="h-px w-10 bg-accent" />
            {eyebrow}
          </p>
        </Reveal>
        <h1 className="mt-6">
          <MaskLine className="font-display text-5xl font-extrabold uppercase leading-[0.95] tracking-tight text-white sm:text-7xl">
            {titleEn}
          </MaskLine>
        </h1>
        <MaskLine delay={0.12} className="mt-4 font-mincho text-lg font-bold text-accent sm:text-2xl">
          {titleJa}
        </MaskLine>
        {desc && (
          <Reveal delay={0.2}>
            <p className="mt-8 max-w-2xl border-l-2 border-accent pl-5 text-sm leading-relaxed text-gray-400 sm:text-base">{desc}</p>
          </Reveal>
        )}
      </div>
    </section>
  );
}
